 
import AppRoute from './components/Routes/appRoute';
function App() {
  return (
    <> 
        <AppRoute /> 
    </>

  );
}

export default App;
